import ReactDOM from "react-dom/client";
import App from "./src/app/App.tsx";
ReactDOM.createRoot(document.getElementById("root")!).render(
  // <React.StrictMode>
  <App />
  // </React.StrictMode>
  // COMMENT: yusuf, if you dont want to use React.StrictMode
  // strick mode re-render the component twice
  // <App />
);
